import { render, staticRenderFns } from "./PgaCertificationsSelectUsersAccessibility.vue?vue&type=template&id=17c20ead&scoped=true&"
import script from "./PgaCertificationsSelectUsersAccessibility.vue?vue&type=script&lang=ts&"
export * from "./PgaCertificationsSelectUsersAccessibility.vue?vue&type=script&lang=ts&"
import style0 from "./PgaCertificationsSelectUsersAccessibility.vue?vue&type=style&index=0&id=17c20ead&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c20ead",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17c20ead')) {
      api.createRecord('17c20ead', component.options)
    } else {
      api.reload('17c20ead', component.options)
    }
    module.hot.accept("./PgaCertificationsSelectUsersAccessibility.vue?vue&type=template&id=17c20ead&scoped=true&", function () {
      api.rerender('17c20ead', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Resource/Certifications/Accessibility/PgaCertificationsSelectUsersAccessibility.vue"
export default component.exports